import { EmailTemplatesAutoReplyListItem } from '@recruitee/http-types';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<EmailTemplatesAutoReplyListItem>()(
    EntityStoreKey.EmailTemplatesAutoReplyCollection,
    {
      idSelector: (entity: { id?: number | string | null }) => entity.id!,
      customActions: adapter => {
        const actions = getEntityCollectionActions(adapter, ({ id }) => id!);

        return {
          updatePositions: (state, payload: number[]) => adapter.markAsPending(state),
          updatePositionsSuccess: actions.fetchCollectionSuccess,
          updatePositionsFailed: actions.fetchCollectionFailed,
          fetchOfferCollection: (state, payload: number | string) => adapter.markAsPending(state),
          fetchOfferCollectionSuccess: actions.fetchCollectionSuccess,
          fetchOfferCollectionFailed: actions.fetchCollectionFailed,
        };
      },
    },
  );

export {
  actions as EmailTemplatesAutoReplyCollectionActions,
  selectors as EmailTemplatesAutoReplyCollectionSelectors,
  reducer as EmailTemplatesAutoReplyCollectionReducer,
  namespace as EmailTemplatesAutoReplyCollectionNamespace,
};
